import api from '@/utils/api';
import LoadingComponent from '@/components/loading-component';
import * as Constants from '@/constants';

export default {
  name: 'ProviderAdd',
  components: {
    LoadingComponent
  },
  props: ['showTooltip'],
  data() {
    return {
      selectedProvider: null,
      selectedProviderCopy: null,
      selectedSchool: null,
      selectedSchoolCopy: null,
      errorMsg: null,
      studentsList: null,
      allSupports: false,
      // provider autocomplete
      providerSearchError: '',
      providerSearchInput: null,
      providerSearchLoading: false,
      providersArray: [],
      // school autocomplete
      schoolSearchError: '',
      schoolSearchInput: null,
      schoolSearchLoading: false,
      schoolArray: [],
      // app loading screen
      showLoading: false,
      retrieveStudentsClicked: false,
      providerInformation: '',
      providerCredentialType: '',
      providerCredentialName: '',
      schoolName: ''
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  },
  methods: {
    clearProviderAutoComplete() {
      if (!this.selectedProvider) {
        this.providersArray = [];
      }
    },
    clearSchoolAutoComplete() {
      if (!this.selectedSchool) {
        this.schoolArray = [];
      }
    },
    getStudentList() {
      this.errorMsg = null;
      this.showLoading = true;
      this.studentsList = null;
      this.retrieveStudentsClicked = true;
      api.get(Constants.GET_STUDENT_SERVICE_LIST_BY_PROVIDER_URL(this.selectedProviderCopy.userId, this.selectedSchoolCopy.schoolId, !this.allSupports))
        .then((res) => {
          if (!res.data.data.length) throw new Error('No students found');
          this.studentsList = res.data.data;
        })
        .catch((error) => {
          this.errorMsg = error.message;
        })
        .finally(() => {
          // set information for title bar
          this.providerInformation = `${this.selectedProviderCopy.firstName} ${this.selectedProviderCopy.lastName}`;
          this.providerCredentialType =
            this.selectedProviderCopy.credentialType ? `/${this.selectedProviderCopy.credentialType}` : null;
          this.providerCredentialName =
            this.selectedProviderCopy.credentialName ? `/${this.selectedProviderCopy.credentialName}` : null;
          this.schoolName = this.selectedSchoolCopy.schoolName;
          // clear form fields
          this.selectedProvider = null;
          this.selectedSchool = null;
          this.showLoading = false;
        });
    },
    addProvider(id) {
      const body = {
        serviceId: id,
        providerUserId: this.selectedProviderCopy.userId
      };
      this.errorMsg = null;
      this.showLoading = true;
      api.post(Constants.ADD_PROVIDER_TO_STUDENT_SERVICE_AND_TEAM_URL(), body)
        .then(() => {
          this.getStudentList();
        })
        .catch((error) => {
          this.errorMsg = error.message;
          this.showLoading = false;
        });
    },
    removeProvider(providerId) {
      this.errorMsg = null;
      this.showLoading = true;
      api.delete(Constants.REMOVE_PROVIDER_FROM_STUDENT_SERVICE_AND_TEAM_URL(providerId))
        .then(() => {
          this.getStudentList(true);
        })
        .catch((error) => {
          this.errorMsg = error.message;
          this.showLoading = false;
        });
    }
  },
  watch: {
    // fires when user toggles the all services switch
    allSupports() {
      // make sure theres a selected provider and selected school before toggling
      if (this.selectedProviderCopy && this.selectedSchoolCopy) this.getStudentList();
    },
    // fires the api call to get providers list
    providerSearchInput() {
      // show loading
      this.providerSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.providerSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.GET_SCHEDULER_PROVIDER_LIST_URL(this.providerSearchInput))
            .then((res) => {
              this.providersArray = res.data.data;
            })
            .catch((error) => {
              this.providerSearchError = error.message;
            })
            .finally(() => {
              // stop loading
              this.providerSearchLoading = false;
            });
        }, 300);
      } else {
        this.providerSearchLoading = false;
      }
    },
    // fires the api call to get school list
    schoolSearchInput() {
      // show loading
      this.schoolSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.schoolSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.GET_SCHEDULER_SCHOOL_LIST_URL(this.schoolSearchInput))
            .then((res) => {
              this.schoolArray = res.data.data;
            })
            .catch((error) => {
              this.schoolSearchError = error.message;
            })
            .finally(() => {
              this.schoolSearchLoading = false;
            });
        }, 300);
      } else {
        this.schoolSearchLoading = false;
      }
    },
    selectedProvider(newVal, oldVal) {
      if (newVal) {
        this.selectedProviderCopy = Object.assign({}, newVal);
      }
      if (!newVal && oldVal) this.providersArray = [];
    },
    selectedSchool(newVal, oldVal) {
      if (newVal) {
        this.selectedSchoolCopy = Object.assign({}, newVal);
      }
      if (!newVal && oldVal) this.schoolArray = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/agency-scheduler/add-by-provider/add-by-provider.js